<template>
  <div class="profile">
    <h1>Profile</h1>
  </div>
</template>

<script>
export default {
  name: "profile",
  components: {}
};
</script>

<style lang="scss"></style>
